// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CK0X","content":"styles_content__2iIt-"};